import {
  makeObservable,
  observable,
  action,
  computed,
  runInAction,
} from "mobx";
import { IObservableInitialState } from "../../models/ICommon";
import {
  IFotaMozlReleaseDetail,
  IFotaTenantReleaseDetail,
  IMzlRelease,
  IMzlReleaseList,
  IMzlReleaseListVM,
} from "../../models/response/IFotaResponse";
import * as baseService from "../service/base-service";
import URLConstants from "../../constants/url.constants";
import toast from "react-hot-toast";
import { formatMessage } from "../../translations/format-message";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import { IFotaAddSysAdmin, IFotaUpdateSysAdmin } from "../../models/Form/IFotaForm";
import { initialFotaMzlState } from "../initial-state/get-all-fota-state";
import { getLanguageFromLocalStorage} from "../../helpers/local-stotrage-helper";
import moment from "moment";
import { DATE_FORMAT, DATE_TIME_FORMAT, getEffectiveDateTime } from "../../constants/common-constants";
import {initialValuesSysAdmin} from '../initial-state/add-edit-system-admin-fota-state';

export class FotaMzlStore {
  initialStateValue = {
    success: false,
    error: '',
    inProgress: false
  }
  error: string | null = null;
  inProgress: boolean = false;
  isModemView: boolean = true;

  addUpdateFotaMzlState: IObservableInitialState = { ...this.initialStateValue }
 
  fotaMzlReleaseList: IMzlReleaseListVM = initialFotaMzlState;
  fotaMzlReleaseState: IObservableInitialState = { ...this.initialStateValue }
  fotaMzlReleaseLatest: IMzlRelease | undefined = undefined;
  fotMzlRelease: IMzlRelease | undefined = undefined;
  deleteFotaMzlState: IObservableInitialState = { ...this.initialStateValue }
  
  constructor() {
    makeObservable(this, {
      fotaMzlReleaseList: observable,
      fotMzlRelease: observable,
      fotaMzlReleaseState: observable,
      fotaMzlReleaseLatest: observable,
      deleteFotaMzlState: observable,
      addUpdateFotaMzlState: observable,
      inProgress: observable,
      error: observable,
      GetFotaMzlReleaseListService: action,
      GetFotaMzlReleaseByIdService: action,
      AddUpdateFotaMzlServiceSysAdminService: action,
      UpdateFotaMzlServiceSysAdminService: action,
      DeleteFotaMzlService: action,
      
      reset: action,
      resetAddUpdateFotaMzlState: action,
      
      resetFotaMzlReleaseState: action,
      
      resetDeleteFotaMzlState: action,
      
      getFotaMzlList: computed,
      getFotaMzlRelease: computed,
      getFotaMzlDetail: computed,
      setIsModemView: action,
    });
  }

  /**
   * Fetches a list of Fota items.
   * @param currentPage - Current page number.
   * @param pageSize - Number of items per page.
   */
  GetFotaMzlReleaseListService = (isModemView:boolean, currentPage: number, pageSize: number) => {
    runInAction(() => (this.inProgress = true));
    const url = isModemView ? `${URLConstants.FotaModemReleaseList}?PageNo=${currentPage}&PageSize=${pageSize}` :
     `${URLConstants.FotaJetReleaseList}?PageNo=${currentPage}&PageSize=${pageSize}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IMzlReleaseListVM>>) => {
        if (response.data.Error) {
          runInAction(
            () => (this.error = response.data.Message)
          );
        } else {
          runInAction(() => {
            this.fotaMzlReleaseList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        runInAction(() => (this.error = err));
      })
      .finally(() => {
        runInAction(() => (this.inProgress = false));
      });
  };

  /**
    * This function is used to map fotaMzlReleaseList to Fota List suitable for Grid Component.
    * @returns Initial Fota Details
    */
  get getFotaMzlList(): IMzlReleaseList[] {
    if (this.fotaMzlReleaseList && this.fotaMzlReleaseList?.Releases.length > 0)
        return this.fotaMzlReleaseList?.Releases.map((fota) => {
            let language = getLanguageFromLocalStorage();
            return {
                Id: fota.Id,
                Description: fota.Description ? fota.Description : "",
                Version: fota.Version ? fota.Version : "",
                File: fota.File ? fota.File : "",
                FileName: fota.FileName ? fota.FileName : "",
                FileType: fota.FileType !== null ? fota.FileType : 0,
                EffectiveDateTimestamp: (fota.EffectiveDateTimestamp && fota.EffectiveDateTimestamp !== "1970-01-01") ? moment(fota.EffectiveDateTimestamp).format(DATE_FORMAT) : "",
                CreatedBy: fota.CreatedBy,
                UpdatedBy: fota.UpdatedBy,
                UpdatedDate: fota.UpdatedDate ? moment(fota.UpdatedDate).format(DATE_TIME_FORMAT) : "",
                Language: language,
                isData: fota.EffectiveDateTimestamp ? (new Date(fota.EffectiveDateTimestamp) > new Date() ? true : false) : false,
                isEdit: fota.EffectiveDateTimestamp ? (new Date(fota.EffectiveDateTimestamp) > new Date() ? true : false) : false,
                isDelete: fota.EffectiveDateTimestamp ? (new Date(fota.EffectiveDateTimestamp) > new Date() ? true : false) : false,
                
            }
        })
    return [];
  }

  /**
   * Fetches Fota item details by ID.
   * @param id - ID of the Fota item.
   */
  GetFotaMzlReleaseByIdService = (isModemView:boolean, id: number) => {
    runInAction(() => (this.fotaMzlReleaseState.inProgress = true));
    const url = isModemView ? `${URLConstants.FotaModemRelease}/${id}` : 
      `${URLConstants.FotaJetRelease}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IMzlRelease>>) => {
        if (response.data.Error) {
          // runInAction(
          //   () => (this.fotaMzlReleaseState.error = response.data.Message)
          // );
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            this.fotMzlRelease = {
              ...response.data.Data,
            };
            this.fotaMzlReleaseState.success = true;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err));
        // runInAction(() => (this.fotaMzlReleaseState.error = err));
      })
      .finally(() => {
        runInAction(() => (this.fotaMzlReleaseState.inProgress = false));
      });
  };

  /**
   * Returns fotMzlRelease which were fetched by Id
   */
  get getFotaMzlRelease(): IFotaAddSysAdmin {
    if (this.fotMzlRelease) return {
      ...this.fotMzlRelease,
      File: "",
      FileContent: this.fotMzlRelease?.File ? this.fotMzlRelease?.File : "",
      FileName: "",
      IsCustomFileNameWithExtension: false,
      IsCustomFileNameWithoutExtension: false,
      WantToUpdateFile: "false",
      EffectiveDateTimestamp: (this.fotMzlRelease.EffectiveDateTimestamp && this.fotMzlRelease.EffectiveDateTimestamp !== "1970-01-01") ? moment(this.fotMzlRelease.EffectiveDateTimestamp).format(DATE_FORMAT) : moment(new Date()).format(DATE_TIME_FORMAT),
    };
    return {...initialValuesSysAdmin, EffectiveDateTimestamp: getEffectiveDateTime()};
  }

  resetFotaMzlReleaseState = () =>{
    this.fotMzlRelease = undefined;
    this.fotaMzlReleaseState = {...this.initialStateValue};
  }

  /**
   * Adds or updates a Fota for SystemAdmin.
   * @param data - Fota item data.
   */
  AddUpdateFotaMzlServiceSysAdminService = (isModemView: boolean, data: IFotaAddSysAdmin) => {
    this.addUpdateFotaMzlState.inProgress = true;
    const url = isModemView ? URLConstants.FotaModemRelease : URLConstants.FotaJetRelease;
    return baseService.postRequest(url, {...data}).then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            let err = response.data.Message
            if (err.includes(":")) {
                let errorMess = err.split(":");
                toast.error( formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
            } else { toast.error(formatMessage(err)); }
          } else {
            this.addUpdateFotaMzlState.success = true;
          }
        }
      )
      .catch((err: any) => {
        if (err.includes(":")) {
            let errorMess = err.split(":");
            toast.error( formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
        } else { toast.error(formatMessage(err)); }
      })
      .finally(() => {
        this.addUpdateFotaMzlState.inProgress = false;
      });
  };

  /**
   * Updates a Fota for SystemAdmin.
   * @param data - Fota item data.
   */
  UpdateFotaMzlServiceSysAdminService = (isModemView: boolean, data: IFotaUpdateSysAdmin, id: number) => {
    this.addUpdateFotaMzlState.inProgress = true;
    data.Id = id;
    const url = isModemView ? URLConstants.FotaModemRelease : URLConstants.FotaJetRelease;
    return baseService.putRequest(url, data)
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            let err = response.data.Message
            if (err.includes(":")) {
                let errorMess = err.split(":");
                toast.error( formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
            } else { toast.error(formatMessage(err)); }
          } else {
            this.addUpdateFotaMzlState.success = true;
          }
        }
      )
      .catch((err: any) => {
        if (err.includes(":")) {
            let errorMess = err.split(":");
            toast.error( formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
        } else { toast.error(formatMessage(err)); }
      })
      .finally(() => {
        this.addUpdateFotaMzlState.inProgress = false;
      });
  };

  resetAddUpdateFotaMzlState = () =>{
    this.addUpdateFotaMzlState = {...this.initialStateValue};
  }

  /**
   * Returns fotaTenantReleaseDetail which were fetched by Id
   */
  get getFotaMzlDetail(): IFotaTenantReleaseDetail | IFotaMozlReleaseDetail | undefined {
    if(this.fotMzlRelease)
      return{
        Version: this.fotMzlRelease.Version !== null ? this.fotMzlRelease.Version : "",
        FileName: this.fotMzlRelease.FileName !== null ? this.fotMzlRelease.FileName : "",
        FileType: this.fotMzlRelease.FileType !== null ? this.fotMzlRelease.FileType : 0,
        EffectiveDateTimestamp: (this.fotMzlRelease.EffectiveDateTimestamp && this.fotMzlRelease.EffectiveDateTimestamp !== "1970-01-01T00:00:00.000Z") ? moment(this.fotMzlRelease.EffectiveDateTimestamp).format(DATE_FORMAT) : "",
        File: "",
        Description: this.fotMzlRelease.Description,
        UpdatedDate: (this.fotMzlRelease.UpdatedDate && this.fotMzlRelease.UpdatedDate !== "1970-01-01T00:00:00.000Z") ? moment(this.fotMzlRelease.UpdatedDate).format(DATE_TIME_FORMAT) : "",
        CreatedDate: (this.fotMzlRelease.CreatedDate && this.fotMzlRelease.CreatedDate !== "1970-01-01T00:00:00.000Z") ? moment(this.fotMzlRelease.CreatedDate).format(DATE_TIME_FORMAT) : "",
    };
  }

  /**
    * This function is used to Delete User by calling an API.
    * @param id : The User Identifier
    * @returns 
    */
  DeleteFotaMzlService = (id: number, isModemView: boolean) => {
    this.deleteFotaMzlState.inProgress = true;
    let url = isModemView ? `${URLConstants.FotaModemRelease}/${id}` : `${URLConstants.FotaJetRelease}/${id}`;
    return baseService.deleteRequest(url)
        .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
            if (response.data.Error) {
                this.deleteFotaMzlState.error = response.data.Message;
                toast.error(formatMessage(response.data.Message));
            }
            else this.deleteFotaMzlState.success = true;
        })
        .catch((err: string) => {
            this.deleteFotaMzlState.error = err;
        }).finally(action(() => { this.deleteFotaMzlState.inProgress = false; }));
  }

  resetDeleteFotaMzlState = () => {
    this.deleteFotaMzlState = {...this.initialStateValue};
  };

  /**
   * Resets all observables to their initial values.
   */
  reset = () => {
    this.fotaMzlReleaseState = {...this.initialStateValue};
    this.addUpdateFotaMzlState = {...this.initialStateValue};
    this.fotaMzlReleaseList = initialFotaMzlState;
    this.fotMzlRelease = undefined;
    this.fotaMzlReleaseLatest = undefined;
  };

  setIsModemView = (modemView: boolean) => {
    this.isModemView = modemView;
    localStorage.setItem('mzl_is_modem_view', modemView.toString())
}

}
const fotaStore = new FotaMzlStore();
export default fotaStore;
